import _Vue from 'vue'
import store from '@/store/index'

interface Lang {
  [key: string]: any
}

import moment from 'moment'
import 'moment/locale/it.js'
import 'moment/locale/es.js'
import {EventBus} from '@/main'

const languages: Lang = {
  it: require('../../res/lang/it_IT/translations.json'),
  en: require('../../res/lang/en_US/translations.json'),
  es: require('../../res/lang/es_ES/translations.json'),
}
/*
let lang = languages.en

// crudely set lang by browser setting
if (navigator && navigator.language) {
  if (navigator.language.startsWith('it')) {
    lang = languages.it
  }
}
*/
let loadedLang: string = 'en'
export default {

  install(Vue: typeof _Vue): void {
    Vue.prototype.$langLoader = (defaultLang?: string) => {
      const configLang = store.state.configuration.appConfig.default_language
      const userLang = store.state.profile.language
      const selected = userLang !== '' ? userLang : configLang
      loadedLang = selected ? selected : defaultLang
      moment.locale(loadedLang)
      EventBus.$emit('langLoaded')
    }


    Vue.prototype.$t = (key: string, replacements: string[], def: string) => {
      const lang = languages[loadedLang]
      if (!replacements) {
        replacements = []
      }

      if (!def) {
        def = key
      }

      let item = lang
      key.split('.').forEach((element) => {
        if (item && item[element]) {
          item = item[element]
        } else {
          item = null
        }
      })

      if (!item) {
        item = def
      }

      for (key in replacements) {
        if (replacements.hasOwnProperty(key)) {
          item = item.replace(new RegExp(':' + key, 'gi'), replacements[key])
        }
      }

      return item
    }

    Vue.prototype.$langAvailable = () => {
      return Object.keys(languages).map((item: string) => {
        switch (item) {
          case 'it':
            return {
              name: 'Italiano',
              code: 'it',
            }
          case 'en':
            return {
              name: 'English',
              code: 'us',
            }
          case 'es':
            return {
              name: 'Español',
              code: 'es',
            }
        }
      })
    }

    Vue.prototype.$currency = (value: number) => {
      const currency = store.state.configuration.appConfig.currency
      if (store.state.configuration.appConfig.round_price_values) {
        value = Math.round(value)
      }
      return `${currency}${value}`
    }
  },
}
